
//select
$("select").selectpicker();

//mobile menu click
$('.navbar-toggle').click(function(){
    $(this).toggleClass("active");
});

$('.searchButn').on('click', function(){
    $('.searchField').toggleClass('active');
})


$('.tabsList a[href="#myInfo"]').tab('show')

$('#hList li').on('click', function(){
    $('#orderHistroy .orderList').addClass('activeOrder')
    $('#hList li').removeClass('active');
    $(this).addClass('active')
})

//equalHeight
equalheight = function(container){

    var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el,
        topPosition = 0;
    $(container).each(function() {
        $el = $(this);
        $($el).height('auto')
        topPostion = $el.position().top;

        if (currentRowStart != topPostion) {
            for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
                rowDivs[currentDiv].height(currentTallest);
            }
            rowDivs.length = 0; // empty the array
            currentRowStart = topPostion;
            currentTallest = $el.height();
            rowDivs.push($el);
        } else {
            rowDivs.push($el);
            currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
        }
        for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
        }
    });
}

$(window).load(function() {
    equalheight('.equalHeight');
});


$(window).resize(function(){
    equalheight('.equalHeight');
});

// product slider
if ($('.productSlider ul').length && $('.gallerySlider').length){
    initProdictSlider();
}

// init protuct slider
function initProdictSlider(){
  productBxSlider = $('.productSlider ul').bxSlider({
         controls: false,
         adaptiveHeight: true
     });
  productBxThumbs = $('.gallerySlider').bxSlider({
        preloadImages: 'all',
        infiniteLoop: false,
        pagerCustom: '#gallery-pager'
    });  
}

// destroy product slider
function destroyProductSlider(){
  productBxSlider.destroySlider();
  productBxThumbs.destroySlider();
}
